import { utcToZonedTime } from "date-fns-tz"
import React from "react"
import {
    HorizontalStack,
    HeadingMedium,
} from "@mallardbay/lib-react-components"

import type { MediaFieldsFragment } from "~graphql/generated/graphql"
import { getShortDistanceToNow } from "~utils/helpers"
import { getLocalTimeZone } from "~utils/date-helpers"
import HorizontalStackSpaceBetween from "~components/shared/todo-lib-react-components/horizontal-stack-space-between"
import Avatar, {
    Size,
} from "~components/shared/todo-lib-react-components/avatar"
import { TextSecondary } from "~components/shared/todo-lib-react-components/text"

interface Props {
    readonly avatar?: MediaFieldsFragment | null
    readonly title: string
    readonly time: string
}

export default function ActivityCardTopSection({ avatar, title, time }: Props) {
    const timeSincePosted = getShortDistanceToNow(
        utcToZonedTime(time, getLocalTimeZone())
    )

    return (
        <HorizontalStackSpaceBetween>
            <HorizontalStack>
                <Avatar size={Size.Small} src={avatar?.url} name={title} />
                <HeadingMedium>{title}</HeadingMedium>
            </HorizontalStack>
            <TextSecondary>{timeSincePosted}</TextSecondary>
        </HorizontalStackSpaceBetween>
    )
}
